import { PortableTextBlock } from '@portabletext/react'
import clsx from 'clsx'
import { SanityButtonProps, SanityImage } from '~/types'
import { Button, ContentEditor } from '~/components'

interface FiftyFiftyProps {
  alignment?: 'left' | 'center' | 'right'
  image: SanityImage
  content: {
    content: PortableTextBlock[]
    button: SanityButtonProps
  }
}

export default function Block5050({
  alignment = 'left',
  image,
  content,
}: FiftyFiftyProps) {
  return (
    <section
      className={clsx('container px-8 py-12 lg:px-16', {
        'text-left': alignment === 'left',
        'text-center': alignment === 'center',
        'text-right': alignment === 'right',
      })}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {image && image.asset && image.asset.url && (
          <img
            className="order-2 mx-auto h-auto w-full lg:order-1"
            src={image.asset.url}
            alt={image.alt}
          />
        )}
        {content && (
          <div className="order-1 flex flex-col items-center justify-center bg-teal-700 px-8 pt-16 text-left lg:order-2 lg:px-20 lg:pt-0">
            <div className="pb-6">
              <ContentEditor content={content.content} />
            </div>
            <div className="pb-6 lg:w-full lg:pb-0">
              <Button
                size="text-base"
                {...content.button}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
